import { render, staticRenderFns } from "./thirdPartyServices.vue?vue&type=template&id=e352f152&scoped=true"
import script from "./thirdPartyServices.vue?vue&type=script&lang=js"
export * from "./thirdPartyServices.vue?vue&type=script&lang=js"
import style0 from "./thirdPartyServices.vue?vue&type=style&index=0&id=e352f152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e352f152",
  null
  
)

export default component.exports